import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import { EndorseNameAppNoRoutingModule } from './endorse-name-app-no-routing.module';
import { EndorseNameAppNoComponent } from './endorse-name-app-no.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EndorseNameAppNoRoutingModule,
    GlobalModule,
  ],
  declarations: [
    EndorseNameAppNoComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EndorseNameAppNoModule {
}
